import { fromZonedTime } from 'date-fns-tz';
import { entityInfoSelectors } from '../reducers/entityInfoSlice';
import { RootState } from '../reducers/rootReducer';

export type DateRangeInput = {
  startDate: string;
  endDate: string;
};

export function transformDateRangeToFarmTimeZone(
  state: RootState,
  range: DateRangeInput,
) {
  const farmTimeZone = entityInfoSelectors.selectFarmTimeZone(state);
  return {
    startDate: fromZonedTime(
      new Date(range.startDate),
      farmTimeZone,
    ).toISOString(),
    endDate: fromZonedTime(new Date(range.endDate), farmTimeZone).toISOString(),
  };
}
